import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import './ActionButton.module.scss'

const VARIANT_CLASS = {
  neutral: 'Uic-ActionButton-neutral',
  primary: 'Uic-ActionButton-primary',
  danger: 'Uic-ActionButton-danger',
}

const propTypes = {
  /** Visible button label. */
  label: PropTypes.node.isRequired,
  /** Font Awesome icon class, e.g. "fas fa-pen-to-square". */
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  /** Tonal emphasis. Reserve `primary` for one recommended action per group; `danger` for destructive. */
  variant: PropTypes.oneOf(['neutral', 'primary', 'danger']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

/**
 * Compact tonal action button (icon + label) — the labeled member of the action-button family
 * (icon-only is `IconButton`). For dense / inline / toolbar actions, not a page CTA.
 */
function ActionButton({ label, icon = null, onClick, variant = 'neutral', disabled = false, className = '' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={clsx('Uic-ActionButton-base', VARIANT_CLASS[variant] ?? VARIANT_CLASS.neutral, className)}
    >
      {icon ? <i className={icon} aria-hidden="true" /> : null}
      <span>{label}</span>
    </button>
  )
}

ActionButton.propTypes = propTypes

export default React.memo(ActionButton)
